module.exports = __webpack_public_path__ + "media/images/bg_rainbow-a40037190594f4c2ebd4e9f8f58e1598.png";